import { createContext, useContext } from "react";
// Types
import { ToolNameValue } from "app/store/pagesToolbar/pagesToolbar.types";

type ContextType = {
  listRef: any;
  pages: any[] | undefined;
  tools: {
    // ToDO: Deprecated. Will be removed in few releases
    bar: Partial<Record<ToolNameValue, any>>;
    additionalBar: Partial<Record<ToolNameValue, any>>;
    settings?: Partial<Record<ToolNameValue, any>>;
    // New design
    newDesignBar: Partial<Record<ToolNameValue, any>>;
    newDesignSidebar: Partial<Record<ToolNameValue, any>>;
  };
  // Hidden tools
  hiddenTools: ToolNameValue[];
  onUpdateHiddenTools: (toolName: ToolNameValue) => void;
};

export const PagesToolbarContext = createContext<ContextType | undefined>(undefined);

export const usePagesToolbarContext = ():ContextType => {
  const context = useContext(PagesToolbarContext);
  if ( !context ) throw new Error('usePagesToolbarContext must be used within a PagesToolbarProvider');
  return context;
};
